import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${COLORS.multiSilver};
  overflow-y: hidden;
  z-index: 1000;
`;

export const ComponentTopBlock = styled.div`
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid ${COLORS.lightSilver};
  margin-bottom: 32px;
`;

export const TitleAndAddButton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 50px;
`;

export const TitleOfPage = styled.span`
  ${FONTS.font24};
  ${FONT_FAMILY.FontMedium};
  text-transform: capitalize;
  color: ${COLORS.black};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 600px;
`;

export const SelectFromTemplates = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
  padding-inline: 10px;
  width: 200px;
  height: 46px;
  border-radius: 8px;
  border: 1px solid #686868;
`;

export const OptionsOfTemplates = styled.div`
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  height: auto;
  padding-bottom: 20px;
  background: ${COLORS.white};
  border: 1px solid ${COLORS.lightSilver};
  border-radius: 8px;
  overflow-y: auto;
`;

export const Option = styled.div`
  display: flex;
  justify-content: space-between;
  padding-inline: 10px;
  padding-top: 10px;
  margin-bottom: 4px;
  width: 100%;
  height: 20px;
`;
export const NameAndIcon = styled.div`
  width: 100%;
  position: relative;
  height: 36px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
`;

export const SampleSpan = styled.span``;
export const SampleImage = styled.img`
  position: ${({ backgroundWhite }) => (backgroundWhite ? 'absolute' : 'unset')};
  top: ${({ backgroundWhite }) => (backgroundWhite ? '16px' : 'unset')};
  right: ${({ backgroundWhite }) => (backgroundWhite ? '14px' : 'unset')};
  cursor: pointer;
`;

export const AddButton = styled.button`
  width: 172px;
  height: 46px;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font18};
  text-transform: capitalize;
  border-radius: 8px;
`;

export const SendOfferButton = styled.button`
  width: 172px;
  height: 46px;
  border-radius: 8px;
  background: transparent;
  border: 1px solid ${COLORS.lightSilver};
`;

export const AboutContentBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
`;

export const DeleteAndSearchBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 432px;
  height: 32px;
`;

export const TableSampleBlock = styled.div`
  display: flex;
  gap: 10px;
  width: ${({ title }) => title && '260px'};
`;

export const EditAndDeleteButton = styled.img`
  cursor: pointer;
`;

export const TitleDescriptionAndStatusWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 150px;
  width: 100%;
  height: 46px;
  margin-top: 14px;
`;

export const InfoInput = styled.input`
  padding-left: 14px;
  width: 100%;
  height: 46px;
  outline: none;
  background: transparent;
  border-radius: 8px;
  border: 1px solid ${COLORS.lightSilver};
`;

export const StatusSelect = styled.select`
  width: 100%;
  height: 46px;
  border-radius: 8px;
  border: 1px solid ${COLORS.lightSilver};
  padding-left: 10px;
  -webkit-appearance: none;
`;

export const OffersWrapper = styled.div`
  display: flex;
  column-gap: 85px;
  row-gap: 40px;
  flex-wrap: wrap;
  width: 100%;
  height: 650px;
  overflow-y: auto;
`;

export const UserOffer = styled.div`
  width: 312px;
  height: 258px;
  background: ${COLORS.white};
  border: 1px solid ${COLORS.lightSilver};
  border-radius: 8px;
`;

export const MainOfferImage = styled.div`
  width: 100%;
  height: 116px;
  background: ${({ image }) => `url(${image})`};
  background-size: cover;
  border-radius: 8px 8px 0 0;
`;

export const AboutDescription = styled.div`
  width: 100%;
  height: 140px;
  padding: 10px;
`;

export const TitleAndButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 24px;
`;

export const TourTitle = styled.span`
  ${FONTS.font16};
  ${FONT_FAMILY.FontMedium};
  color: ${COLORS.mainColor};
`;

export const SmallButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 130px;
  height: 24px;
`;

export const EditNoteDeleteButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 24px;
  background: ${COLORS.multiGray};
`;

export const ActionsImage = styled.img`
  cursor: pointer;
`;

export const DescriptionOfOffer = styled.span`
  text-transform: capitalize;
  margin-top: 10px;
  color: ${COLORS.lightSilver};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ViewPackageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 500px;
`;

export const PackageMainInfo = styled.div`
  display: flex;
  width: 100%;
  height: 164px;
  margin-top: 10px;
`;

export const TitleAndPriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 62px;
  width: 100%;
  height: 164px;
`;

export const PackageTitle = styled.span`
  ${FONTS.font24};
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontMedium};
`;

export const PackagePrice = styled.span`
  ${FONTS.font36};
  font-size: 46px;
  color: ${COLORS.mainColor};
`;

export const PackageImage = styled.div`
  width: 386px;
  flex-shrink: 0;
  height: 164px;
  background: url(${({ image }) => image});
  background-size: cover;
  border-radius: 8px;
`;

export const PackageInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const PackageDescription = styled.span`
  width: 100%;
  height: auto;
  color: ${COLORS.mainColor};
  ${FONTS.font16};
  ${FONT_FAMILY.FontMedium};
`;

export const DescriptionParagraph = styled.span`
  color: ${COLORS.mainColor};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
`;

export const LinkToUrl = styled.a`
  text-decoration: none;
  color: ${COLORS.mainColor};
  ${FONTS.font16};
  cursor: pointer;
`;

export const CloseIcon = styled.img`
  position: absolute;
  right: 5px;
  bottom: 500px;
  cursor: pointer;
`;
